import { Action } from '@ngrx/store';
import { ContactPerson } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person.model';

export enum ActionTypes {
  FETCH_CONTACTS = '[Receiving Person] Fetch Contacts',
  STORE_CONTACTS = '[Receiving Person] Store Contacts',
  ADD_NEW_CONTACT = '[Receiving Person] Add New Contact',
  CLEAR_CONTACTS = '[Receiving Person] Clear Contacts',
  SELECT_CONTACT = '[Receiving Person] Select Contact',
}

export class FetchContacts implements Action {
  readonly type: string = ActionTypes.FETCH_CONTACTS;
  constructor(public payload?: { selectContact: number }) {}
}

export class StoreContacts implements Action {
  readonly type: string = ActionTypes.STORE_CONTACTS;
  constructor(public payload: ContactPerson[]) {}
}

export class AddNewContact implements Action {
  readonly type: string = ActionTypes.ADD_NEW_CONTACT;
  constructor(public payload: ContactPerson) {}
}

export class ClearContacts implements Action {
  readonly type: string = ActionTypes.CLEAR_CONTACTS;
  constructor(public payload?: any) {}
}

export class SelectContact implements Action {
  readonly type: string = ActionTypes.SELECT_CONTACT;
  constructor(public payload: number) {}
}

export type Actions = FetchContacts | StoreContacts | AddNewContact | ClearContacts | SelectContact;
